import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import Card from '../components/Card'
import Heading from '../components/Heading'
import TableVertical, {
  TableVerticalHeader
} from '../components/TableVertical'
import itemService from '../services/item.service'
import { i18n } from '../i18n/i18n'

interface Props {
  heading: string
  item: ItemData
  quantity: number
}

export default class ItemQuantityList extends Component<Props> {
  headers: TableVerticalHeader[] = [
    { heading: i18n('Pallets'), path: 'pallets' },
    { heading: i18n('Cases'), path: 'cases' },
    { heading: i18n('Units'), path: 'units' }
  ]

  get data () {
    const { item, quantity } = this.props
    return itemService.productionTotalCalculationData(item, quantity)
  }

  render () {
    return (
      <Card>
        <Heading
          className="mb-2"
          text={this.props.heading} />
        <TableVertical
          headers={this.headers}
          data={this.data} />
      </Card>
    )
  }
}
